import type { ScratchCampaign } from './types'

export function initScratchCampaign(): ScratchCampaign {
  return {}
};
